import React from 'react'

import Button from 'components_new/atoms/Button'

import SimpleDialog from 'components_new/molecules/SimpleDialog'
import { useTranslation } from 'language/translator'

interface DeleteDialogProps {
  handleDelete: () => void
  open: boolean
  onClose: () => void
  title: string
}

const DeleteDialog = (props: DeleteDialogProps) => {
  const { onClose, open, title, handleDelete } = props

  const { t } = useTranslation()

  return (
    <SimpleDialog
      title={t('dashboards', 'delete_widget_title')}
      contentText={
        <>
          <b>
            &quot;
            {title}
            &quot;
          </b>{' '}
          {t('guides', 'delete_confirmation_suffix')}
        </>
      }
      onClose={onClose}
      open={open}
      actions={
        <>
          <Button onClick={onClose} variant="text">
            {t('global', 'cancel')}
          </Button>
          <Button onClick={handleDelete} color="error" variant="contained">
            {t('global', 'delete')}
          </Button>
        </>
      }
    />
  )
}

export default DeleteDialog
